import type {
  SubscriptionsSerializer,
  OfferCampaign,
  IApiResponse,
  LitResSubscriptionInfoSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { standardRetryingRequestOptions } from "../api/retrying";

export const subscriptionsApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getSubscriptionPrices: build.query<
      SubscriptionsSerializer[],
      {
        subscriptionType: OfferCampaign;
      }
    >({
      query: ({ subscriptionType }) => {
        /*
          В рамках эксперимента с тарифными планами, по умолчанию отправляем experimental флаг.
          На клиенте обязательно используйте useSubscriptionClassList для валидного доступа к данным.
        */
        const searchParams = new URLSearchParams({
          subscription_type: String(subscriptionType),
          experimental: "true",
          deprecated: "true",
        });

        return {
          url: `/foundation/api/subscriptions?${searchParams.toString()}`,
        };
      },
      transformResponse: (response: IApiResponse<SubscriptionsSerializer[]>) =>
        response.payload.data,
      extraOptions: {
        ...standardRetryingRequestOptions,
      },
    }),
    getUserSubscriptionsInfo: build.query<
      LitResSubscriptionInfoSerializer,
      null
    >({
      query: () => ({
        url: `/foundation/api/users/me/subscriptions/detailed`,
      }),
      transformResponse: (
        response: IApiResponse<LitResSubscriptionInfoSerializer>
      ) => response.payload.data,
      extraOptions: {
        ...standardRetryingRequestOptions,
      },
    }),
    changeSubscriptionRebill: build.mutation<
      void,
      {
        rebillId: number;
        subscriptionId: number;
      }
    >({
      query({ rebillId, subscriptionId }) {
        return {
          url: `/foundation/api/users/me/subscriptions/${subscriptionId}/rebill/change`,
          method: "PUT",
          body: {
            rebill_id: rebillId,
          },
        };
      },
      extraOptions: {
        ...standardRetryingRequestOptions,
      },
    }),
    subscribeToWink: build.mutation<void, void>({
      query: () => ({
        url: `/foundation/api/subscriptions/wink`,
        method: "POST",
      }),
    }),
  }),
});
